module.exports = __webpack_public_path__ + "media/images/icon-coupon-d11b8c4faa73ac81b9e21d28ba75d165.png";